import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const updateRateCard = api(async function updateRateCard({ id, data }) {
    return mutate(
        gql`
            mutation UpdateRateCard($id: String!, $data: RateCardInput!) {
                updateRateCard(id: $id, data: $data)
            }
        `,
        { id, data },
        { returns: "updateRateCard" }
    )
})
